export default function Header() {
  return (
    <header
      style={{
        width: "100%",
        height: "100px",
        background: "white",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        gap: "20px",
        padding: "10px 20px"
      }}
    >
      <img
  src="/ter-ignis_cafe.png"
  alt="Logo Bar"
  className="zoom-img"
  style={{ height: "90px" }}
/>

   </header>
  );
}
